import React from 'react';

const IslandAdventurePage = () => {
  return (
    <div className="pt-20">
      {/* Hero Section */}
      <section className="relative h-[60vh] bg-gradient-to-r from-[#FF69B4] to-[#FFB6C1] flex items-center justify-center">
        <div className="absolute inset-0 opacity-30">
          <img
            src="https://customer-assets.emergentagent.com/job_berry-isle-reborn/artifacts/75n53wh9_IMG_1476.jpeg"
            alt="Island Tours & Adventures"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="relative text-center text-white px-4 z-10">
          <h1 className="text-5xl md:text-6xl brand-script mb-4" data-testid="adventure-hero-title">
            Island Tours & Adventures 🏝️
          </h1>
          <p className="text-xl md:text-2xl max-w-3xl mx-auto">
            Discover the magic of Strawberry Island – where adventure meets relaxation!
          </p>
        </div>
      </section>

      {/* About Strawberry Island */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold mb-6" style={{ color: '#20B2AA' }}>
                Welcome to Strawberry Island! 🍓
              </h2>
              <p className="text-lg text-gray-700 mb-4">
                Located just a quick 30-second power boat ride east of downtown Tofino, 
                Strawberry Island is your private paradise escape! Whether you book a cabin or just an island tour, 
                you will experience a unique island featuring floating homes that sit right on the water. 
                It's the perfect blend of adventure and comfort! Whether you're looking for things to do in Tofino or 
                seeking a peaceful retreat, Strawberry Island offers unforgettable experiences 
                from wildlife watching to hot springs tours, fishing charters, and pristine 
                nature exploration.
              </p>
              <div className="bg-gradient-to-r from-[#20B2AA]/10 to-[#FF69B4]/10 rounded-xl p-6 mt-6">
                <p className="text-lg font-semibold" style={{ color: '#FF1493' }}>
                  🌟 Pro Tip: Book a charter or tour and add cabin accommodation for the 
                  ultimate island experience! Camp under the stars or cozy up in one of 
                  our floating cabins.
                </p>
              </div>
            </div>
            <div className="rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://customer-assets.emergentagent.com/job_berry-isle-reborn/artifacts/s6dm6wnn_2strawberryislandarial.png"
                alt="Strawberry Island Aerial View"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Historic Island Tours */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold mb-4" style={{ color: '#20B2AA' }}>
              Historic Island Tours 📜
            </h2>
            <p className="text-xl text-gray-700 max-w-3xl mx-auto">
              Discover the rich history and fascinating stories of Tofino and the surrounding islands
            </p>
          </div>

          {/* Photo Gallery */}
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-12">
            <div className="rounded-xl overflow-hidden shadow-lg hover:scale-105 transition-transform duration-300">
              <img
                src="https://customer-assets.emergentagent.com/job_berry-isle-reborn/artifacts/250z438t_IMG_1582.jpeg"
                alt="Historic Tour"
                className="w-full h-64 object-cover"
              />
            </div>
            <div className="rounded-xl overflow-hidden shadow-lg hover:scale-105 transition-transform duration-300">
              <img
                src="https://customer-assets.emergentagent.com/job_berry-isle-reborn/artifacts/5w79zlni_IMG_2643.jpeg"
                alt="Island History"
                className="w-full h-64 object-cover"
              />
            </div>
            <div className="rounded-xl overflow-hidden shadow-lg hover:scale-105 transition-transform duration-300">
              <img
                src="https://customer-assets.emergentagent.com/job_berry-isle-reborn/artifacts/ww3y45cs_IMG_3492-preview.JPG"
                alt="Historic Landmarks"
                className="w-full h-64 object-cover"
              />
            </div>
            <div className="rounded-xl overflow-hidden shadow-lg hover:scale-105 transition-transform duration-300">
              <img
                src="https://customer-assets.emergentagent.com/job_berry-isle-reborn/artifacts/mes1i4jl_IMG_8049.jpg"
                alt="Coastal Heritage"
                className="w-full h-64 object-cover"
              />
            </div>
            <div className="rounded-xl overflow-hidden shadow-lg hover:scale-105 transition-transform duration-300">
              <img
                src="https://customer-assets.emergentagent.com/job_berry-isle-reborn/artifacts/6j4lx1rj_IMG_0802.jpeg"
                alt="Tofino Heritage"
                className="w-full h-64 object-cover"
              />
            </div>
            <div className="rounded-xl overflow-hidden shadow-lg hover:scale-105 transition-transform duration-300">
              <img
                src="https://images.unsplash.com/photo-1622220082969-56959cef7a4d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwxfHx0b3RlbSUyMHBvbGV8ZW58MHx8fHwxNzY0ODIwNjE1fDA&ixlib=rb-4.1.0&q=85"
                alt="Indigenous Totem Pole"
                className="w-full h-64 object-cover"
              />
            </div>
          </div>

          <div className="bg-gradient-to-br from-[#FF69B4]/10 to-[#FFB6C1]/10 rounded-2xl p-8 max-w-4xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="text-center">
                <div className="text-6xl mb-4">🌅</div>
                <h3 className="text-2xl font-bold mb-3" style={{ color: '#20B2AA' }}>
                  Morning Tours
                </h3>
                <p className="text-gray-700 mb-4">
                  Start your day exploring the historic sites and learning about the indigenous 
                  heritage, early settlers, and maritime history of the area.
                </p>
                <div className="bg-white rounded-lg p-4 shadow-md">
                  <p className="text-3xl font-bold" style={{ color: '#FF69B4' }}>$50/person</p>
                  <p className="text-sm text-gray-600 mt-1">Duration varies by tour</p>
                </div>
              </div>
              <div className="text-center">
                <div className="text-6xl mb-4">🌇</div>
                <h3 className="text-2xl font-bold mb-3" style={{ color: '#20B2AA' }}>
                  Evening Tours
                </h3>
                <p className="text-gray-700 mb-4">
                  Experience the magic of golden hour while hearing captivating stories of 
                  Tofino's past, local legends, and cultural significance.
                </p>
                <div className="bg-white rounded-lg p-4 shadow-md">
                  <p className="text-3xl font-bold" style={{ color: '#FF69B4' }}>$50/person</p>
                  <p className="text-sm text-gray-600 mt-1">Duration varies by tour</p>
                </div>
              </div>
            </div>
            <div className="mt-8 text-center">
              <p className="text-lg text-gray-700 mb-4">
                🏛️ Learn about indigenous culture, historic landmarks, maritime heritage, 
                and the fascinating evolution of this coastal paradise!
              </p>
              <a
                href="mailto:joel@fishingtofino.net?subject=Historic Tour Inquiry"
                className="inline-block bg-gradient-to-r from-[#20B2AA] to-[#5DADE2] text-white px-8 py-4 rounded-full text-lg font-semibold hover:scale-105 transition-transform shadow-lg"
              >
                Book Historic Tour 📜
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Hot Springs Cove */}
      <section id="hot-springs" className="py-16 bg-gradient-to-b from-white to-[#F5F5F5]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold mb-4" style={{ color: '#FF69B4' }}>
              Hot Springs Cove Tour ♨️
            </h2>
            <p className="text-xl text-gray-700 max-w-3xl mx-auto">
              One of BC's most spectacular natural wonders awaits you!
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
            <div className="order-2 md:order-1">
              <div className="space-y-6">
                <div className="flex items-start space-x-4">
                  <div className="text-4xl">🚤</div>
                  <div>
                    <h3 className="text-xl font-bold mb-2" style={{ color: '#20B2AA' }}>
                      Scenic Boat Ride
                    </h3>
                    <p className="text-gray-700">
                      Cruise through pristine waters to Maquinna Provincial Park. 
                      Keep your eyes peeled for whales, sea lions, and bears!
                    </p>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="text-4xl">🌲</div>
                  <div>
                    <h3 className="text-xl font-bold mb-2" style={{ color: '#20B2AA' }}>
                      Rainforest Boardwalk
                    </h3>
                    <p className="text-gray-700">
                      Take a magical 30-minute walk on a wooden boardwalk through 
                      ancient old-growth forest. These trees are MASSIVE!
                    </p>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="text-4xl">♨️</div>
                  <div>
                    <h3 className="text-xl font-bold mb-2" style={{ color: '#20B2AA' }}>
                      Geothermal Pools
                    </h3>
                    <p className="text-gray-700">
                      Climb down the rocks and choose from seven natural hot pools. 
                      Soak up the warmth while enjoying breathtaking ocean views!
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="order-1 md:order-2 rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://customer-assets.emergentagent.com/job_berry-isle-reborn/artifacts/xzjoauet_IMG_2487.jpeg"
                alt="Hot Springs Cove"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Wildlife & Island Tours */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold mb-4" style={{ color: '#20B2AA' }}>
              Wildlife & Island Tours 🐋
            </h2>
            <p className="text-xl text-gray-700 max-w-3xl mx-auto">
              You'll NEVER get enough of the scenery around Tofino!
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-gradient-to-br from-[#20B2AA]/10 to-[#5DADE2]/10 rounded-2xl p-6">
              <div className="text-5xl mb-4 text-center">🐻</div>
              <h3 className="text-2xl font-bold mb-3 text-center" style={{ color: '#FF69B4' }}>
                Bear Watching
              </h3>
              <p className="text-gray-700 text-center">
                Spot majestic black bears foraging along the shoreline. 
                Safe viewing from the boat – nature at its finest!
              </p>
            </div>
            <div className="bg-gradient-to-br from-[#FF69B4]/10 to-[#FFB6C1]/10 rounded-2xl p-6">
              <div className="text-5xl mb-4 text-center">🐋</div>
              <h3 className="text-2xl font-bold mb-3 text-center" style={{ color: '#20B2AA' }}>
                Whale Encounters
              </h3>
              <p className="text-gray-700 text-center">
                Gray whales, humpbacks, and orcas frequent these waters. 
                Witnessing a breach is pure magic!
              </p>
            </div>
            <div className="bg-gradient-to-br from-[#5DADE2]/10 to-[#87CEEB]/10 rounded-2xl p-6">
              <div className="text-5xl mb-4 text-center">🦭</div>
              <h3 className="text-2xl font-bold mb-3 text-center" style={{ color: '#FF1493' }}>
                Sea Lions
              </h3>
              <p className="text-gray-700 text-center">
                Watch playful sea lions lounging on rocks and diving for fish. 
                They're hilarious and adorable!
              </p>
            </div>
          </div>
          <div className="mt-12 bg-gradient-to-r from-[#20B2AA] to-[#5DADE2] rounded-2xl p-8 text-white">
            <h3 className="text-2xl font-bold mb-4">🦐🦀 Prawning & Crabbing Adventure!</h3>
            <p className="text-lg mb-4">
              We've got prawn and crab traps set up all around the inlets. Help us pull them 
              and we'll send you home with a fresh batch of seafood! We'll clean them and 
              cook them in garlic butter RIGHT ON THE BOAT. Doesn't get fresher than that!
            </p>
            <p className="text-lg">
              ✨ When we max out our offshore catch or if it's too rough, we head inshore 
              for salmon and more delicious seafood!
            </p>
          </div>
        </div>
      </section>

      {/* Island Tours - We're More Than Just Fishing */}
      <section className="py-16 bg-gradient-to-br from-[#20B2AA]/10 to-[#5DADE2]/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold mb-4" style={{ color: '#FF69B4' }}>
              We're More Than Just Fishing! 🌟
            </h2>
            <p className="text-xl text-gray-700 max-w-3xl mx-auto">
              Island Tours designed to showcase the incredible beauty and diversity of Tofino and surrounding areas
            </p>
          </div>

          <div className="bg-white rounded-2xl shadow-xl p-8 mb-8">
            <h3 className="text-3xl font-bold mb-6 text-center" style={{ color: '#20B2AA' }}>
              🚤 Customized Island Tour Experiences
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="space-y-4">
                <div className="flex items-start space-x-3">
                  <span className="text-2xl">🗺️</span>
                  <div>
                    <h4 className="font-bold text-lg mb-1" style={{ color: '#FF69B4' }}>
                      Custom Itineraries
                    </h4>
                    <p className="text-gray-700">
                      Design your perfect day exploring hidden coves, pristine beaches, and secret spots 
                      only locals know about!
                    </p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <span className="text-2xl">📸</span>
                  <div>
                    <h4 className="font-bold text-lg mb-1" style={{ color: '#FF69B4' }}>
                      Photography Tours
                    </h4>
                    <p className="text-gray-700">
                      Capture stunning landscapes, wildlife, and unforgettable moments with plenty 
                      of stops for perfect photo opportunities.
                    </p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <span className="text-2xl">🌅</span>
                  <div>
                    <h4 className="font-bold text-lg mb-1" style={{ color: '#FF69B4' }}>
                      Sunset & Sunrise Tours
                    </h4>
                    <p className="text-gray-700">
                      Experience magical golden hour tours with breathtaking views you'll never forget!
                    </p>
                  </div>
                </div>
              </div>
              <div className="space-y-4">
                <div className="flex items-start space-x-3">
                  <span className="text-2xl">🏝️</span>
                  <div>
                    <h4 className="font-bold text-lg mb-1" style={{ color: '#FF69B4' }}>
                      Beach Hopping
                    </h4>
                    <p className="text-gray-700">
                      Visit multiple pristine beaches and secluded islands in one amazing adventure!
                    </p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <span className="text-2xl">🦦</span>
                  <div>
                    <h4 className="font-bold text-lg mb-1" style={{ color: '#FF69B4' }}>
                      Wildlife Spotting
                    </h4>
                    <p className="text-gray-700">
                      See sea otters, seals, eagles, and maybe even whales during your island exploration!
                    </p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <span className="text-2xl">🥾</span>
                  <div>
                    <h4 className="font-bold text-lg mb-1" style={{ color: '#FF69B4' }}>
                      Combined Adventures
                    </h4>
                    <p className="text-gray-700">
                      Mix island touring with hot springs, light fishing, or beach exploration – your choice!
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="text-center mt-8">
            <a
              href="mailto:joel@fishingtofino.net?subject=Island Tour Inquiry"
              className="inline-block bg-gradient-to-r from-[#FF69B4] to-[#FFB6C1] text-white px-10 py-5 rounded-full text-xl font-semibold hover:scale-105 transition-transform shadow-lg"
            >
              Book Your Custom Island Tour 🗺️
            </a>
          </div>
        </div>
      </section>

      {/* Kids Activities */}
      <section className="py-16 bg-gradient-to-b from-white to-[#F5F5F5]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold mb-4" style={{ color: '#FF69B4' }}>
              Kids Activities 👧👦
            </h2>
            <p className="text-xl text-gray-700 max-w-3xl mx-auto">
              Make memories the whole family will treasure forever!
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="rounded-2xl overflow-hidden shadow-xl">
              <img
                src="https://images.unsplash.com/photo-1758264511125-5a4d4b12835d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHxraWRzJTIwYmVhY2glMjBhY3Rpdml0aWVzfGVufDB8fHx8MTc2MzQ0NDgzM3ww&ixlib=rb-4.1.0&q=85"
                alt="Beach Activities"
                className="w-full h-64 object-cover"
              />
              <div className="p-6 bg-white">
                <h3 className="text-xl font-bold mb-2" style={{ color: '#20B2AA' }}>
                  🏖️ Beach Exploration
                </h3>
                <p className="text-gray-700">
                  Build sandcastles, hunt for shells, play beach games, and let the 
                  kids' imaginations run wild on our pristine shores!
                </p>
              </div>
            </div>
            <div className="rounded-2xl overflow-hidden shadow-xl">
              <img
                src="https://images.unsplash.com/photo-1751809999727-d820f7959325?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHw0fHxraWRzJTIwYmVhY2glMjBhY3Rpdml0aWVzfGVufDB8fHx8MTc2MzQ0NDgzM3ww&ixlib=rb-4.1.0&q=85"
                alt="Water Safety"
                className="w-full h-64 object-cover"
              />
              <div className="p-6 bg-white">
                <h3 className="text-xl font-bold mb-2" style={{ color: '#20B2AA' }}>
                  🛟 Safe Water Fun
                </h3>
                <p className="text-gray-700">
                  Kayaking, paddleboarding, and swimming with proper safety gear. 
                  We've got kid-sized life jackets for everyone!
                </p>
              </div>
            </div>
            <div className="rounded-2xl overflow-hidden shadow-xl">
              <img
                src="https://images.unsplash.com/photo-1515725228994-2265d7f9e92d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwyfHxuYXR1cmUlMjBleHBsb3JhdGlvbnxlbnwwfHx8fDE3NjM0NDQ4NDB8MA&ixlib=rb-4.1.0&q=85"
                alt="Nature Exploration"
                className="w-full h-64 object-cover"
              />
              <div className="p-6 bg-white">
                <h3 className="text-xl font-bold mb-2" style={{ color: '#20B2AA' }}>
                  🌲 Nature Discovery
                </h3>
                <p className="text-gray-700">
                  Explore tide pools, spot wildlife, learn about local ecosystems. 
                  Every rock hides a new adventure!
                </p>
              </div>
            </div>
          </div>
          <div className="mt-12 bg-gradient-to-r from-[#FF69B4] to-[#FFB6C1] rounded-2xl p-8 text-white text-center">
            <h3 className="text-3xl font-bold mb-4">🎉 Kids Programs Coming Soon!</h3>
            <p className="text-xl">
              We're developing awesome educational programs for young adventurers. 
              Stay tuned for fishing lessons, marine biology tours, and wilderness skills workshops!
            </p>
          </div>
        </div>
      </section>

      {/* Wellness & Yoga */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold mb-4" style={{ color: '#20B2AA' }}>
              Wellness & Yoga Retreats 🧘
            </h2>
            <p className="text-xl text-gray-700 max-w-3xl mx-auto">
              Find your zen on Strawberry Island – where peace meets paradise!
            </p>
          </div>

          {/* Instructor Feature */}
          <div className="bg-gradient-to-br from-[#FF69B4]/10 to-[#FFB6C1]/10 rounded-2xl p-8 mb-12 max-w-4xl mx-auto">
            <div className="text-center">
              <h3 className="text-3xl font-bold mb-4" style={{ color: '#20B2AA' }}>
                Guided by Nicole Rice Wellness
              </h3>
              <p className="text-lg text-gray-700 mb-4">
                Experience authentic yoga instruction rooted in the <strong>Ashtanga Yoga Darsana</strong> tradition, 
                influenced by the teaching methodologies of Krishnamacharya. Nicole brings professional yoga 
                instruction and holistic wellness practices to the stunning natural setting of Strawberry Island.
              </p>
              <a
                href="https://nicolericewellness.ca"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block bg-gradient-to-r from-[#FF69B4] to-[#FFB6C1] text-white px-8 py-3 rounded-full font-semibold hover:scale-105 transition-transform"
              >
                Visit Nicole Rice Wellness →
              </a>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
            <div className="rounded-2xl overflow-hidden shadow-xl">
              <img
                src="https://images.unsplash.com/photo-1599552692549-e3ce4a23cac9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxjb2FzdGFsJTIweW9nYXxlbnwwfHx8fDE3NjM0NDQ4NzN8MA&ixlib=rb-4.1.0&q=85"
                alt="Beach Yoga"
                className="w-full h-64 object-cover"
              />
              <div className="p-6 bg-white">
                <h3 className="text-xl font-bold mb-2" style={{ color: '#FF69B4' }}>
                  🌅 Coastal Yoga Classes
                </h3>
                <p className="text-gray-700">
                  Practice authentic Ashtanga-based yoga on the beach with the sound of waves 
                  and fresh ocean air. Sunrise sessions are pure magic!
                </p>
              </div>
            </div>
            <div className="rounded-2xl overflow-hidden shadow-xl">
              <img
                src="https://images.unsplash.com/photo-1524863479829-916d8e77f114?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHx5b2dhJTIwbmF0dXJlfGVufDB8fHx8MTc2MzUzNzU5OXww&ixlib=rb-4.1.0&q=85"
                alt="Pacific Northwest Yoga"
                className="w-full h-64 object-cover"
              />
              <div className="p-6 bg-white">
                <h3 className="text-xl font-bold mb-2" style={{ color: '#FF69B4' }}>
                  🧘 Meditation & Mindfulness
                </h3>
                <p className="text-gray-700">
                  Guided meditation sessions in stunning natural settings. Reconnect with yourself 
                  and find inner peace surrounded by the beauty of nature.
                </p>
              </div>
            </div>
            <div className="rounded-2xl overflow-hidden shadow-xl">
              <img
                src="https://images.unsplash.com/photo-1687436874174-977fdd9e2cb8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwyfHx3ZWxsbmVzcyUyMHJldHJlYXR8ZW58MHx8fHwxNzYzNDQ0ODc5fDA&ixlib=rb-4.1.0&q=85"
                alt="Group Wellness"
                className="w-full h-64 object-cover"
              />
              <div className="p-6 bg-white">
                <h3 className="text-xl font-bold mb-2" style={{ color: '#FF69B4' }}>
                  🌿 Holistic Wellness Retreats
                </h3>
                <p className="text-gray-700">
                  Multi-day retreats combining traditional yoga practices, meditation, nature immersion, 
                  and holistic wellness. Transform your mind, body, and spirit!
                </p>
              </div>
            </div>
          </div>
          <div className="bg-gradient-to-br from-[#20B2AA]/10 to-[#FF69B4]/10 rounded-2xl p-8">
            <h3 className="text-2xl font-bold mb-4 text-center" style={{ color: '#20B2AA' }}>
              ✨ Wellness Offerings ✨
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <ul className="space-y-3 text-gray-700">
                <li className="flex items-center">
                  <span className="text-2xl mr-3">🧘‍♀️</span>
                  Daily yoga classes (all levels welcome!)
                </li>
                <li className="flex items-center">
                  <span className="text-2xl mr-3">🌊</span>
                  Ocean sound meditation sessions
                </li>
                <li className="flex items-center">
                  <span className="text-2xl mr-3">🌿</span>
                  Forest bathing experiences
                </li>
              </ul>
              <ul className="space-y-3 text-gray-700">
                <li className="flex items-center">
                  <span className="text-2xl mr-3">🥗</span>
                  Healthy meal planning & prep
                </li>
                <li className="flex items-center">
                  <span className="text-2xl mr-3">💆</span>
                  Stress relief workshops
                </li>
                <li className="flex items-center">
                  <span className="text-2xl mr-3">🌅</span>
                  Sunrise & sunset rituals
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Boat Moorage & Water Taxi Section */}
      <section id="taxi-services" className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold mb-4" style={{ color: '#20B2AA' }}>
              Island Services 🚤⚓
            </h2>
            <p className="text-xl text-gray-700 max-w-3xl mx-auto">
              Convenient transportation and secure moorage at Strawberry Island
            </p>
          </div>
          
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {/* Water Taxi Service */}
            <div className="bg-gradient-to-br from-[#FF69B4]/10 to-[#FFB6C1]/10 rounded-2xl p-8">
              <div className="text-center mb-6">
                <div className="text-5xl mb-4">🚤</div>
                <h3 className="text-2xl font-bold mb-4" style={{ color: '#FF69B4' }}>
                  Water Taxi Service
                </h3>
                <p className="text-lg text-gray-700 mb-6">
                  Fast, reliable water taxi service between downtown Tofino and Strawberry Island. 
                  Just 30 seconds away from the mainland!
                </p>
                <div className="grid grid-cols-1 gap-4 mt-6">
                  <div className="bg-white rounded-lg p-4 shadow-md">
                    <h4 className="font-bold text-lg mb-2" style={{ color: '#20B2AA' }}>
                      On-Demand Service
                    </h4>
                    <p className="text-gray-600">Call Pearl an hour before pickup</p>
                  </div>
                  <div className="bg-white rounded-lg p-4 shadow-md">
                    <h4 className="font-bold text-lg mb-2" style={{ color: '#20B2AA' }}>
                      Competitive Pricing
                    </h4>
                    <p className="text-gray-600">Affordable rates for guests and visitors</p>
                  </div>
                </div>
                <div className="mt-6">
                  <a
                    href="mailto:joel@fishingtofino.net?subject=Water Taxi Service Inquiry"
                    className="inline-block bg-gradient-to-r from-[#FF69B4] to-[#FFB6C1] text-white px-8 py-4 rounded-full text-lg font-semibold hover:scale-105 transition-transform shadow-lg"
                  >
                    Inquire About Water Taxi 🚤
                  </a>
                </div>
              </div>
            </div>

            {/* Boat Moorage */}
            <div className="bg-gradient-to-br from-[#20B2AA]/10 to-[#5DADE2]/10 rounded-2xl p-8">
              <div className="text-center mb-6">
                <div className="text-5xl mb-4">⚓</div>
                <h3 className="text-2xl font-bold mb-4" style={{ color: '#FF69B4' }}>
                  Boat Moorage
                </h3>
                <p className="text-lg text-gray-700 mb-6">
                  Need a safe place to dock your boat while exploring Tofino? We offer 
                  secure moorage at Strawberry Island with competitive per-foot rates!
                </p>
                <div className="grid grid-cols-1 gap-4 mt-6">
                  <div className="bg-white rounded-lg p-4 shadow-md">
                    <h4 className="font-bold text-lg mb-2" style={{ color: '#20B2AA' }}>
                      Daily Moorage
                    </h4>
                    <p className="text-gray-600">Competitive daily rates by boat length</p>
                  </div>
                  <div className="bg-white rounded-lg p-4 shadow-md">
                    <h4 className="font-bold text-lg mb-2" style={{ color: '#20B2AA' }}>
                      Monthly Moorage
                    </h4>
                    <p className="text-gray-600">Special rates for extended stays</p>
                  </div>
                </div>
                <div className="mt-6">
                  <a
                    href="mailto:joel@fishingtofino.net?subject=Boat Moorage Inquiry"
                    className="inline-block bg-gradient-to-r from-[#20B2AA] to-[#5DADE2] text-white px-8 py-4 rounded-full text-lg font-semibold hover:scale-105 transition-transform shadow-lg"
                  >
                    Contact for Moorage Rates ⚓
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-gradient-to-r from-[#20B2AA] to-[#FF69B4] text-white">
        <div className="max-w-4xl mx-auto text-center px-4">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Ready for Your Island Adventure? 🏝️
          </h2>
          <p className="text-xl mb-8">
            Whether you're seeking thrilling wildlife encounters, peaceful wellness retreats, 
            or family-friendly fun – Strawberry Island has it all!
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="mailto:joel@fishingtofino.net"
              className="bg-white text-[#20B2AA] px-8 py-4 rounded-full text-lg font-semibold hover:scale-105 transition-transform shadow-lg"
              data-testid="contact-cta-btn"
            >
              Contact Us Today! 📧
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default IslandAdventurePage;